<template>
    <div class="profile-tabs__wrapper">
        <tabs class="profile-tabs" v-if="members.array.length && transactions.array.length">
            <tab :name="tab.title" :selected="tab.selected" v-for="(tab, index) in [members, transactions]" :key="index">

                <div class="profile-tabs__body" v-if="tab.title === $store.getters.t('organizations_profile_tabs_members') && tab.array.length > 0">


                    <div class="profile-tabs__nav d-flex" v-if="tab.meta.last_page > 1">

                        <span class="lnr lnr-chevron-left" :class="{'disabled': tab.meta.current_page === 1}" @click.prevent="membersPage = membersPage - 1"></span>
                        <span class="lnr lnr-chevron-right" :class="{'disabled': tab.meta.last_page === tab.meta.current_page}" @click.prevent="membersPage = membersPage + 1"></span>

                    </div>

                    <div class="profile-tabs__body-item d-flex" v-for="(item,index) in tab.array" :key="index">

                        <template v-if="item">
                            <div class="profile-tabs__body-header">
                                <a :href="`/volunteer/${item.id}/profile`" class="profile-tabs__body-image">
                                    <img :src="`/storage/${item.avatar.path.replace('original', 'avatar')}`" :alt="item.name" v-if="item.avatar">
                                    <span v-else v-text="getUserPM(item.name || 'Anonymous')"></span>
                                </a>
                            </div>

                            <div class="profile-tabs__body-content">
                                <a :href="`/volunteer/${item.id}/profile`" class="profile-tabs__body-name">{{ item.name }}</a>
                                <div class="profile-tabs__body-info" v-text="item.total_donated"></div>

                                <span class="remove" @click.prevent="removeUser(item.id)" v-if="organization.owner && currentUserData && organization.owner.id === currentUserData.id">
                                    &#215;
                                </span>

                            </div>
                        </template>


                    </div>

                </div>
                <div class="profile-tabs__body" v-else-if="tab.title === $store.getters.t('organizations_profile_tabs_transactions')  && tab.array.length > 0">

                    <div class="profile-tabs__nav d-flex" v-if="tab.meta.last_page > 1">

                        <span class="lnr lnr-chevron-left" :class="{'disabled': tab.meta.current_page === 1}" @click.prevent="transactionPage = transactionPage - 1"></span>
                        <span class="lnr lnr-chevron-right" :class="{'disabled': tab.meta.last_page === tab.meta.current_page}" @click.prevent="transactionPage = transactionPage + 1"></span>

                    </div>


                    <div class="profile-tabs__body-item d-flex" v-for="({pet = null, project = null ,...item},index) in tab.array" :key="index">

                        <template v-if="item && pet">
                            <div class="profile-tabs__body-header">
                                <a :href="`/pets/${pet.id}`" class="profile-tabs__body-image">
                                    <img :src="`/storage/${pet.avatar.path}`" :alt="pet.name" v-if="pet.avatar">
                                    <span v-else v-text="getUserPM(pet.name || 'Anonymous')"></span>
                                </a>
                            </div>

                            <div class="profile-tabs__body-content">
                                <a :href="`/pets/${pet.id}`" class="profile-tabs__body-name">{{ pet.name }}</a>
                                <div class="profile-tabs__body-info" v-text="">{{item.credit}} EUR</div>
                            </div>
                        </template>

                        <template v-if="item && project">
                            <div class="profile-tabs__body-header">
                                <a :href="`/projects/${project.id}`" class="profile-tabs__body-image">
                                    <img :src="`/storage/${project.avatar.path}`" :alt="project.name" v-if="project.avatar">
                                </a>
                            </div>

                            <div class="profile-tabs__body-content">
                                <a :href="`/projects/${project.id}`" class="profile-tabs__body-name">{{ project.name }}</a>
                                <div class="profile-tabs__body-info" v-text="">{{item.credit}} EUR</div>
                            </div>
                        </template>

                    </div>

                </div>
                <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-else>
                    {{$store.getters.t('facilities_list_empty')}}
                </div>


            </tab>
        </tabs>

        <div class="profile-tabs"  :class="tabOpen ? 'profile-tabs--open' : ''" v-if="!members.array.length || !transactions.array.length">
            <div class="profile-tabs__header-text"
                 @click.prevent="tabOpen = !tabOpen">
                {{ members.array.length ? members.title : transactions.title }}
            </div>
            <transition name="slide" >

                <template  v-if="members.array.length">
                    <div class="profile-tabs__body" v-show="tabOpen">
                        <div class="profile-tabs__nav d-flex" v-if="members.meta.last_page > 1">

                            <span class="lnr lnr-chevron-left" :class="{'disabled': members.meta.current_page === 1}" @click.prevent="membersPage = membersPage - 1"></span>
                            <span class="lnr lnr-chevron-right" :class="{'disabled': members.meta.last_page === members.meta.current_page}" @click.prevent="membersPage = membersPage + 1"></span>

                        </div>

                        <div class="profile-tabs__body-item d-flex" v-for="(item,index) in members.array" :key="index">

                            <template v-if="item">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/volunteer/${item.id}/profile`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${item.avatar.path.replace('original', 'avatar')}`" :alt="item.name" v-if="item.avatar">
                                        <span v-else v-text="getUserPM(item.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/volunteer/${item.id}/profile`" class="profile-tabs__body-name">{{ item.name }}</a>
                                    <span class="remove" @click.prevent="removeUser(item.id)" v-if="organization.owner && currentUserData && organization.owner.id === currentUserData.id">
                                        &#215;
                                    </span>
                                </div>
                            </template>


                        </div>

                    </div>
                </template>
                <template  v-else-if="transactions.array.length">
                    <div class="profile-tabs__body" v-show="tabOpen">

                        <div class="profile-tabs__nav d-flex" v-if="transactions.meta.last_page > 1">

                            <span class="lnr lnr-chevron-left" :class="{'disabled': transactions.meta.current_page === 1}" @click.prevent="transactionPage = transactionPage - 1"></span>
                            <span class="lnr lnr-chevron-right" :class="{'disabled': transactions.meta.last_page === transactions.meta.current_page}" @click.prevent="transactionPage = transactionPage + 1"></span>

                        </div>

                        <div class="profile-tabs__body-item d-flex" v-for="({pet = null, project = null ,...item},index) in transactions.array" :key="index">

                            <template v-if="item && pet">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${pet.id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${pet.avatar.path}`" :alt="pet.name" v-if="pet.avatar">
                                        <span v-else v-text="getUserPM(pet.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/pets/${pet.id}`" class="profile-tabs__body-name">{{ pet.name }}</a>
                                    <div class="profile-tabs__body-info" v-text="">{{item.credit}} EUR</div>
                                </div>
                            </template>

                            <template v-if="item && project">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/projects/${project.id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${project.avatar.path}`" :alt="project.name" v-if="project.avatar">
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/projects/${project.id}`" class="profile-tabs__body-name">{{ project.name }}</a>
                                    <div class="profile-tabs__body-info" v-text="">{{item.credit}} EUR</div>
                                </div>
                            </template>

                        </div>

                    </div>
                </template>
                <template v-else>
                    <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-show="tabOpen">

                        Список пуст

                    </div>
                </template>

            </transition>

        </div>

    </div>
</template>

<script>

import Tabs from '../Profile/tabs/Tabs';
import Tab from '../Profile/tabs/Tab';

export default {
    name: "OrganizationProfileTabs",
    props: ['organization'],
    components: {
        Tabs,
        Tab
    },
    data() {
        return{

            membersPage: 1,
            transactionPage: 1,

            tabOpen: true,

            members: {
                title: this.$store.getters.t('organizations_profile_tabs_members'),
                selected: true,
                array: [],
                meta: null
            },
            transactions:{
                title: this.$store.getters.t('organizations_profile_tabs_transactions'),
                selected: false,
                array: [],
                meta: null
            },
        }
    },


    mounted(){
      this.getOrganizationMembers();
      this.getOrganizationTransactions();
    },
    computed: {
        currentUserData() {
            return this.$store.getters.getUserData;
        },
    },
    methods:{


        removeUser(idx){
            let params = {
                user_id: idx
            };

            axios.post(`/api/organizations/${this.organization.id}/member-remove`, params)
                .then(response => {
                    response = response.data;
                    if(response.success){
                        this.getOrganizationMembers()
                    }
                })
                .catch(error => {
                    error = error.response.data
                    if(!error.success) console.log(error)
                })
        },

        getOrganizationTransactions(){

            let url = `/api/organizations/${this.organization.id}/donations`;

            axios.get(url, {params: {per_page: 10, page: this.transactionPage}})
                .then(response => {
                    response = response.data;
                    if(response.success){

                        this.transactions.array = response.data
                        this.transactions.meta = response.meta
                        this.transactionPage = response.meta.current_page
                    }

                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                })

        },

        getOrganizationMembers(){

            let url = `/api/organizations/${this.organization.id}/members`;

            axios.get(url, {params: {per_page: 10, page: this.membersPage}})
                .then(response => {
                    response = response.data;
                    if(response.success){

                        this.members.array = response.data
                        this.members.meta = response.meta
                        this.membersPage = response.meta.current_page

                    }

                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                })

        },

        getUserPM(name){
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

    },

    watch:{
        transactionPage(){
            this.getOrganizationTransactions()
        },
        membersPage(){
            this.getOrganizationMembers()
        }

    }


}
</script>

<style scoped>

</style>
